const VEHICLE_CLASS_OPTIONS = [
  { value: 'CAR', label: '汽車' },
  { value: 'MOTO', label: '機車' },
];

const GENDER_OPTIONS = [
  { value: 'MALE', label: '男' },
  { value: 'FEMALE', label: '女' },
];

const POLICY_TYPE_OPTIONS = [
  { value: 'COMPULSORY', label: '強制險' },
  { value: 'VOLUNTARY', label: '任意險' },
];

export { GENDER_OPTIONS, POLICY_TYPE_OPTIONS, VEHICLE_CLASS_OPTIONS };
